/**
 * Foreground push handler. Imported for its SIDE EFFECT from the root layout so
 * the handler is registered on JS module load — before any notification can
 * arrive — NOT inside a component effect.
 *
 * Uses the expo-notifications ~0.32 API (`shouldShowBanner` / `shouldShowList`);
 * the older `shouldShowAlert` is deprecated and would show no foreground banner.
 */
import { Platform } from 'react-native'
import * as Notifications from 'expo-notifications'

// Web has no native notification handler; the in-app bell covers it.
if (Platform.OS !== 'web') {
  Notifications.setNotificationHandler({
    handleNotification: async () => ({
      shouldShowBanner: true,
      shouldShowList: true,
      shouldPlaySound: true,
      shouldSetBadge: false,
    }),
  })
}
